import React, { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    signOut(auth).then(() => {
      navigate('/login');
    });
  }, [navigate]);

  return <p className="mt-10 text-center">Disconnessione in corso...</p>;
}
